import { Component, Inject } from '@angular/core';
import { BaseComponent } from "../base.component";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from "../auth/auth.service";
import { ControlContainer, NgForm } from "@angular/forms";
import { DOCUMENT } from "@angular/common";
import { environment } from "../../../../environments/environment";
import { RestClient } from '../../rest-client.service';

/**
 * App-Component
 */
@Component({
    selector: 'skitbs-login',
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css']
})
export class LoginComponent extends BaseComponent {

    login: string;
    passwd: string;
    year = new Date().getFullYear()
    backgroundColor = environment.backgroundColor;
    logoImage = environment.logoImage;
    botFrameVisible = false;
    botLinkVisible = environment.TENANT_NR === '64';
    privacyStatementConfirmed: boolean;
    cookieUseConfirmed: boolean;

    /**
     * Constructor.
     * @param restClient
     */
    constructor(private authService: AuthService, public router: Router, private route: ActivatedRoute, @Inject(DOCUMENT) private _document) {
        super();

        // ---------------------------
        // autologin from Android-URL
        // ---------------------------
        let pLoginFromURL = this.route.snapshot.paramMap.get("cpnr");
        this.logi(pLoginFromURL);
        if (pLoginFromURL != null) {
            this.login = pLoginFromURL;
            if (this.authService.getToken() != null) {
                this.router.navigate(['/orders'])
            }
        }
    }

    /**
     * Lifecycle.
     */
    ngOnInit(): void {
        this._document.body.style.backgroundColor = this.backgroundColor;
        this.privacyStatementConfirmed = localStorage.getItem('privacyStatementConfirmed') === 'true';
        this.cookieUseConfirmed = localStorage.getItem('cookieUseConfirmed') === 'true';
    }

    ngOnDestroy() {
        this._document.body.style.backgroundColor = '#FFFFFF';
    }

    /**
     * Action.
     */
    onLogin() {
        this.authService
            .auth(this.login, this.passwd)
            .subscribe((aTokenXBVO) => {
                this.router.navigate(['/orders'])
            });
    }

    /**
     * Action.
     */
    onLogout() {
        this.authService.logout();
    }

        /**
     * Action.
     */
    onChangePassword() {
        this.goToUrl(environment.TENANT_SERVER_URL + "/skitbs/public/changePasswordStart.xhtml")
    }

    onConfirmPrivacyStatement() {
        this.privacyStatementConfirmed = true;
        localStorage.setItem('privacyStatementConfirmed', 'true');
    }

    cookieConfirmationChanged(event: any) {
        localStorage.setItem('cookieUseConfirmed', event.checked ? 'true' : 'false');
    }

}
